const ImageContainer = ({ children }) => {
  return (
    <span className="anticon pt-1 flex items-center justify-center" role="img">
      {children}
    </span>
  );
};
export default ImageContainer